const Form057SC = {
    stepName: {
        statement: "重要事项",
        information: "基本资料",
        check: "选择甲/乙/丙/丁/戊部",
        sectionA: "甲部",
        sectionB: "乙部",
        sectionC: "丙部",
        sectionD: "丁部",
        sectionE: "戊部",
        certify: "声明",
        confirmation: "确认",
    },
    errorMsg: {
        date: {
            afterThisDate: "请在{{name}} {{targetDate}} 之后选择日期",
            beforeThisDate: "请在{{name}} {{targetDate}} 之前选择日期",
            laterThanDate: "日期不得晚于本学科学年的8月31日",
        },
        schLeave: "学校部 = 休假时间 >= 1天",
        bdgLeave: "宿舍部 = 休假时间 > 2天",
    },
    label: {
        notes: "备注",
        terms: "声明",
        agree: "申请人应仔细阅读并同意",
        data: "关于隐私数据的注释",
        read: "本人已阅读，理解并同意上述条款及细则",
        schoolInfor: "学校资料",
        schoolName: "学校名称",
        schoolCode: "学校代码",
        month: "月份",
        year: "年份",
        example: "例如：",
        assuming:
            "假设合资格申领「津贴」的时期是由2月5日至5月26日，计算合资格月数的方法如下：",
        claimSNG: "申领表格选择",
        selectSNG: "请选择",
        claim: "新／修订",
        post: "职位",
        section: "部门",
        periodFrom: "开始时间",
        periodTo: "结束时间",
        leavePeriodFrom: "休假开始时间",
        leavePeriodTo: "休假结束时间",
        calendar: "历日数目",
        a: "工作日数",
        b: "日薪率",
        workingDay: "工作日数",
        dailyRate: "日薪率",
        c: "合资格月数",
        d: "月薪",
        e: "强积金供款津贴",
        subsidy: "强积金供款津贴",
        f: "「津贴」金额",
        salaryAmount: "薪金",
        totalSNG: "总额（「津贴」金额）",
        attached:
            "新：新申领津贴的职位／修订：修订的申领（随附（前次日期）的申领表格副本）。",
        attachedTitle: "所附日期为以前索赔的副本",
        remark: "备注",
        indicate: "请注明以下文件",
        leaveInfor: "休假护士的资料",
        sngInfor: "「津贴」的资料",
        name: "姓名",
        SPN: "职员参考编号",
        reason: "缺勤原因",
        claimDailyRated: "本人欲申领发还日薪代职护士薪金，详情如下：",
        supplyInfo: "代职护士的资料",
        supplyName: "代职护士姓名",
        supplyFrom: "代职开始时间",
        supplyTo: "代职结束时间",
        salaryTotal: "总额（薪金）",
        staffNumber: "职员编号",
        contractFrom: "合约开始时间",
        contractTo: "合约结束时间",
        salarySubTotal: "小计（薪金）",
        subsidySubTotal: "小计（强积金供款）",
        allTotal: "总额（薪金+强积金供款）",
        certify: "本人证实：",
        emoluments: "有关薪酬已付予",
        needCheck: "您需要至少选择一个选项",
        leave: "休假时期",
        vacancyPeriod: "空缺期",
        previousClaimDated: "随附（前次日期）的申领表格副本",
        attachment: "附件",
        MPFAttachment: "强积金供款副本",
        postNumber: "职位数量",
        dailyRateAttachment: "就聘用日薪代职护士申领发还薪金收据副本",
        previousClaim: "本学年已提交之申请表格",
        previousClaimNumber: "请注明前次申领表格编号",
        MPFInformation: "强积金供款证明资料",
        from: "由",
        to: "至",
        postNo: "职位数量",
        applicationNo: "申请编号",
        adminType: "校监／校长",
        adminName: "校监／校长姓名",
        date: "日期",
        contactPerson: "联络人",
        telNo: "电话号码",
        sSDO: "高级学校发展主任",
        ssdo1: "副本送：",
        ssdo2: "高级学校发展主任（",
        ssdo3: "）",
        subventions: "致：教育局经常津贴组",
        attn: "[经办人：一级会计主任（经常津贴）]",
        certify1: "本人证实 –",
        and: "及",
        name1: "",
        name2: "姓名",
    },
    secValue: {
        sch: "学校部",
        bdg: "宿舍部",
    },
    previousClaimValue: {
        unchange: "不更改前次申领表格",
        delete: "刪除前次申领表格",
        change: "更改前次申领表格",
    },
    supplyValue: {
        nurse: "日薪代职护士 ",
        trustees: "强积金计划的受托人",
    },
    sectionValue: {
        SectionA: "甲部 以护士长空缺职位换取「津贴」",
        SectionB: "乙部 以注册护士空缺职位换取「津贴」",
        SectionC: "丙部 以「津贴」代替护士放取核准假期的临时补缺人员安排",
        SectionD: "丁部 (日薪代职护士薪金) 雇主无须向强积金计划供款",
        SectionE:
            "戊部 (日薪代职护士薪金) 雇主须向强积金计划供款（代职期须连续60天或以上）",
    },
    leaveValue: {
        vacancy: "少于30天的休假时期",
        revocable: "不少于30天的休假时期",
    },
    vacancyValue: {
        vacancy: "少于30天的空缺期",
        revocable: "不少于30天而可撤回的空缺冻结期",
    },
    claimValue: {
        N: "新申领津贴的职位",
        R: "修订的申领",
    },
    postValue: {
        NO: "护士长",
        RN: "注册护士",
        EN: "登记护士",
    },
    adminValue: {
        supervisor: "校监",
        schoolHead: "校长",
    },
    sSDOValue: {
        0: "北区",
        1: "葵青区",
        2: "西贡区",
        3: "东区",
        4: "屯门区",
        5: "九龙城区",
        6: "观塘区",
        7: "南区",
        8: "油尖旺区",
        9: "荃湾区",
        10: "沙田区",
        11: "深水埗区",
        12: "大埔区",
        13: "湾仔区",
        14: "离岛区",
        15: "中西区",
        16: "元朗区",
        17: "黄大仙区",
    },
    noteList: [
        {
            text: "填写‘√’号以表示护士空缺职位／休假护士属于学校部或宿舍部。\n如申领津贴／薪金的职位属于学校部及寄宿部，请“增加”附加部分并填写相应信息。",
        },
        {
            text: "工作日数不应包括学校部或宿舍部假期、公众假期、由学校自行订定的假期或护士无须执行职务的任何周日。",
        },
        {
            text: "有关资助学校代职人员当前适用的日薪率，请参阅相关的教育局通函。为（i）填补少于30天的护士长及注册护士的冻结职位；或（ii）放取少于30天核准假期的护士长或注册护士（包括具精神科护理训练的注册护士）安排临时补缺人员的代职护士津贴金额，以注册护士代职人员的日薪率计算。为申领发还日薪代职护士薪金，护 士长及注册护士的代职薪金以注册护士代职人员的日薪率计算。",
        },
        {
            text: "计算由起始日直至完结日（首尾两天包括在内）的合资格申领「津贴」的月数，包含以下3个元素：",
        },
        {
            text: "",
        },
        {
            text: "如合资格申领期达60天或以上，强积金计划雇主供款（月薪的5%，并以现行强积金规例所订的最高金额为上限）将会包括在内。如换取现金津贴的护士空缺冻结期或护士放取核准假期的临时补缺期少于60个历日，而须向强积金供款，请提供证明资料。",
        },
        {
            text: "填写休假护士的职员参考编号。",
        },
        {
            text: "请注意，学校必须按照《资助则例》、《学校行政手册》的相关条文及教育局通告第1／2006号、第16／2015号（侍产假适用）以及第16／2018号（产假适用）的规定批假。",
        },
    ],
    five: [
        {
            text: "填写护士长职位的起薪点，即总薪级表第26点的金额；",
        },
        {
            text: "填写注册护士职位的中点薪金，即总薪级表第20点的金额；",
        },
        {
            text: "填写登记护士职位的中点薪金，即总薪级表第15点的金额",
        },
    ],
    calculate: [
        {
            text: "合资格日数在起始月份的历日总数中所占的比例（如适用）；",
        },
        {
            text: "完整的历月数（如适用）；以及",
        },
        {
            text: "合资格日数在完结月份历日总数中所占的比例（如适用）。",
        },
    ],
    exampleList: [
        {
            text: "起始月份的合资格日数为24日（2月5日至2月28日）除以28日（2月份的历日总数）=0.857个月；",
        },
        {
            text: "由3月至4月有两个完整的历月数；",
        },
        {
            text: "完结月份的合资格日数为26日（5月1日至26日）除以31日（五月份的历日总数）=0.839个月；以及",
        },
        {
            text: "合资格申领月数应为上述3个元素的总和（计算至3个小数位），即0.857+2+0.839=3.696。",
        },
    ],
    termList: [
        {
            text: "（就聘用日薪代职护士申领发还薪金）有关薪酬已付予",
        },
        {
            text: "随附有关收据，以供记录存档；",
        },
        {
            text: "本校已获校董会／法团校董会及大多数护士同意，在本学年上述期间冻结甲部及乙部所载的护士职位；",
        },
        {
            text: "冻结甲部及乙部所载的护士职位并申领「津贴」，是因为该（等）核准编制的职位在上述期间有空缺及此项申领符合「津贴」所列明的申领条件；以及",
        },
        {
            text: "本校没有就甲部至戊部所列的假期／空缺向政府申领其他津贴。",
        },
        {
            text: "本校会把任何多收取的津贴退还教育局。",
        },
    ],
    symbolList: [
        {
            text: "（i）",
        },
        {
            text: "（ii）",
        },
        {
            text: "（iii）",
        },
        {
            text: "（iv）",
        },
    ],
    // statementList: [
    //     {
    //         text: "请提交电子表格或纸质表格，请注意，如果提交了重复的申请，处理过程可能会受影响。",
    //     },
    //     {
    //         text: "如欲查询有关本表格所搜集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向有关高级学校发展主任提出",
    //     },
    // ],
    importantNotes: {
        p_title: "个人资料收集声明",
        p1_1: "教育局会利用本表格所载的个人资料，作以下其中一种或多种用途︰",
        p1_a: "办理与聘用有关的事宜；",
        p1_b: "处理发放薪金津贴，以及计算公积金的供款和赠款；",
        p1_c: "进行核数工作；",
        p1_d: "进行研究及统计资料，以便规划教育服务；",
        p1_e: "处理有关教育专业人员发展的事宜；",
        p1_f: "执行《教育条例》、《教育规例》及附属《补助/津贴学校公积金规则》(第279章)。",

        p2: "申请人必须在本表格上填写个人资料。申请人如不提供这些资料，申请的处理工作及结果或会受影响。",
        p3: "本表格所搜集的个人资料，或会向其他获授权的政府决策局/部门/机构披露作上述用途。",
        p4: "根据《个人资料(私隐)条例》，第18和22条及附表1保障资料第6原则的规定，你有权要求查阅及改正你的个人资料。要求查阅的权利，包括要求提供本表格所载个人资料的副本，但须缴付费用。",
        p5: "如欲查询有关本表格所搜集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向教育局提出。",
    },
};
export default Form057SC;
